export default "__VITE_ASSET__d408ba71__"